import { BrowserModule } from '@angular/platform-browser';
import {LOCALE_ID, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import {NgbModule, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';

// // for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// // for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// // for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';

import { AdminGuard } from './shared/guard/admin.guard';
import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';

import { OverlayModule } from '@angular/cdk/overlay';
import {AuthInterceptor} from './auth/services/authconfig.interceptor';
import {ErrorInterceptor} from './auth/services/error.interceptor';
import {TreeviewModule} from '@charmedme/ngx-treeview';
import {LoginOptComponent} from './auth/login-opt/login-opt.component';
import {ForgotPasswordComponent} from './auth/forgot-password/forgot-password.component';
import {ForgotPasswordOtpComponent} from './auth/forgot-password-otp/forgot-password-otp.component';
import {ForgotPasswordResetComponent} from './auth/forgot-password-reset/forgot-password-reset.component';
import {StudentLoginComponent} from "./auth/student-login/student-login.component";
import {TeacherLoginComponent} from "./auth/teacher-login/teacher-login.component";
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {SecurityModule} from "./components/security/security.module";
import {PublicSavIssueComponent} from "./public/public-sav-issue/public-sav-issue.component";
import {NgSelectModule} from '@ng-select/ng-select';
registerLocaleData(localeFr);


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  // return-invoice new TranslateHttpLoader(http, './locale/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    StudentLoginComponent,
    TeacherLoginComponent,
    LoginOptComponent,
    ForgotPasswordComponent,
    ForgotPasswordOtpComponent,
    ForgotPasswordResetComponent,
    PublicSavIssueComponent
  ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        OverlayModule,
        SharedModule,
        AppRoutingModule,
        HttpClientModule,
        NgbModule,
        NgbNavModule,
        NgSelectModule,
        TreeviewModule.forRoot(),
        ToastrModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),

        // for HttpClient use:
        LoadingBarHttpClientModule,
        // for Router use:
        LoadingBarRouterModule,
        // for Core use:
        LoadingBarModule,
        SecurityModule
    ],
  providers: [AdminGuard, CookieService, {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  }, {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true,
  },
    {
      provide: Window,
      useValue: window,
    },
    { provide: LOCALE_ID, useValue: 'fr-FR' }
  ],
  exports: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
